// Third party
import clsx from "clsx";

// Icons
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface IIconToShowProps {
	error?: boolean;
	iconError?: boolean;
}

const IconToShow = ({ error = false, iconError = false }: IIconToShowProps) => {
	const defaultIconStyles = {
		sx: { fontSize: "14px" },
		className: clsx("!h-[21px] pb-[3px] mr-[0.25rem]", {
			"text-alert-color": error,
		}),
	};

	const IconComponent = iconError ? ErrorOutlineRoundedIcon : InfoOutlinedIcon;

	return <IconComponent {...defaultIconStyles} />;
};

export default IconToShow;
